import { float, marker } from './specs'
import type { IndicatorDef } from './types'

/**
 * The candle-pattern def factory: every CDL* indicator is the same shape — an
 * overlay on the candles with one `marker` output carrying TA-Lib's raw signal
 * (100 / −100 / 0, ±80 for the "match on one end" engulfing/harami cases), no
 * inputs except `penetration` where TA-Lib has it, and a constant lookback
 * read from the pattern's TA_CDL*_Lookback (see math/candle/<pattern>.ts).
 * The picker sorts patterns by label, so no `order`.
 */
export interface CdlSpec {
  /** The TA-Lib function name (`CDLDOJI`). */
  id: string
  /** Human label, also the legend title. */
  label: string
  /** TA_CDL*_Lookback at the default candle settings. */
  lookback: number
  /** TA-Lib's default penetration, for the patterns that take one. */
  penetration?: number
}

export function cdlDef({ id, label, lookback, penetration }: CdlSpec): IndicatorDef {
  const hasPenetration = penetration !== undefined
  return {
    id,
    version: 1,
    label,
    shortLabel: label,
    pane: 'main',
    category: 'patterns',
    series: 'price',
    inputs: hasPenetration ? [float('penetration', penetration, 'Penetration', 0, 1, 0.1)] : [],
    outputs: [marker('pattern', label)],
    talib: {
      functions: [id],
      expr: hasPenetration ? `${id}(open, high, low, close, penetration={penetration})` : `${id}(open, high, low, close)`,
    },
    listed: true,
    tailSafe: true,
    lookback: () => lookback,
  }
}
